import gql from 'graphql-tag';

/**
 * Mutation to create a new credit for a submission.
 *
 * @param input - Credit data including type, name, user, and social media information (required)
 * @returns Created credit with creditId, creditType, name, user, and socialMedia
 * @usedIn Submission forms (EditSubmissionForm, SubmissionForm)
 */
export const CREATE_CREDIT = gql`
  mutation createCredit($input: CreditInput!) {
    createCredit(input: $input) {
      creditId
      creditType {
        typeName
      }
      name
      user {
        userId
        preferredUsername
      }
      socialMedia {
        type
        link
      }
    }
  }
`;

/**
 * Mutation to update an existing credit.
 *
 * @param id - The credit ID to update (required)
 * @param updates - Credit update data including name, user, and social media information (required)
 * @returns Updated credit with creditId, name, socialMedia, and user
 * @usedIn Submission forms (EditSubmissionForm, SubmissionForm)
 */
export const UPDATE_CREDIT = gql`
  mutation updateCredit($id: ID!, $updates: UpdateCreditInput!) {
    updateCredit(id: $id, updates: $updates) {
      creditId
      name
      socialMedia {
        type
        link
      }
      user {
        userId
        preferredUsername
      }
    }
  }
`;

/**
 * Mutation to delete a credit by ID.
 *
 * @param id - The credit ID to delete (required)
 * @returns Boolean indicating success
 * @usedIn Submission forms (EditSubmissionForm, SubmissionForm)
 */
export const DELETE_CREDIT = gql`
  mutation deleteCredit($id: ID!) {
    deleteCredit(id: $id)
  }
`;
